import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Grid } from "@material-ui/core";
import styles from "./OnlineTradeIn.module.scss";
import HasPermissionTo from "../../../common/HasPermissionTo";
import CapitalizeText from "../../../utils/CapitalizeText";
import SharedToolTip from "../../../shared/sharedToolTip/SharedToolTip";
import { NOTNULL_OR_NOTUNDEFINED } from "../../../utils/EmpUtil";

class OnlineTradeIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltipOneOpen: false,
      tooltipTwoOpen: false,
    };
    this.canViewTradeIn =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "tradeIn:view"
      );
    this.canWriteTradeIn =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "tradeIn:write"
      );
  }

  toggleTooltipOne = () => {
    this.setState((prevState) => ({
      tooltipOneOpen: !prevState.tooltipOneOpen,
    }));
  };

  toggleTooltipTwo = () => {
    this.setState((prevState) => ({
      tooltipTwoOpen: !prevState.tooltipTwoOpen,
    }));
  };

  getTooltip(infoVersion) {
    return infoVersion === 1 ? (
      <div className={styles.tooltip} data-testid="valuation-tooltip">
        <SharedToolTip
          className={styles.tooltip}
          open={this.state.tooltipOneOpen}
          closeTooltip={this.toggleTooltipOne}
          openTooltip={this.toggleTooltipOne}
          title={this.props.t("DealerDashboard.tradeIn")}
          body={this.getTooltipBody()}
        />
      </div>
    ) : (
      <div className={styles.tooltip}>
        <SharedToolTip
          className={styles.tooltip}
          open={this.state.tooltipTwoOpen}
          closeTooltip={this.toggleTooltipTwo}
          openTooltip={this.toggleTooltipTwo}
          title={this.props.t("DealerDashboard.tradeIn")}
          body={this.getTooltipBody()}
        />
      </div>
    );
  }
  getTooltipBody() {
    return (
      <div>
        <div>
          {this.props.t("TradeIn.setBy")}: {this.props.tradeInDetails.userId}
        </div>
        <div>
          {this.props.t("TradeIn.date")}:{" "}
          {this.props.tradeInDetails.acceptedDate}
        </div>
      </div>
    );
  }

  render() {
    const GridItem = ({ label, value, edit, info, infoVersion }) => {
      return (
        <Grid item xs={3}>
          <div className={styles.gridItem}>
            <span className={styles.label}>
              {label}
              {edit && (
                <button
                  data-testid="edit-valuation"
                  className={styles.linkButton}
                  onClick={this.props.openDialogEdit}
                >
                  {this.props.t("DealerVehicles.edit")}
                </button>
              )}
            </span>
            <span className={styles.value}>
              {this.props.parseBoolean(value) || "-"}
              {info && this.getTooltip(infoVersion)}
            </span>
          </div>
        </Grid>
      );
    };

    return (
      <div className={styles.tradeInWrapper}>
        <span className={styles.subHeader}>
          {this.props.t("TradeIn.vehicleDetails")}
        </span>
        <Grid container>
          <GridItem
            label={this.props.t("TradeIn.registrationNumber")}
            value={this.props.tradeInDetails.registrationNumber}
          />

          <GridItem
            label={this.props.t("TradeIn.model")}
            value={this.props.tradeInDetails.vehicleModel}
          />

          <GridItem
            label={this.props.t("TradeIn.transmission")}
            value={this.props.tradeInDetails.transmission}
          />

          <GridItem
            label={this.props.t("TradeIn.tradeInRequest")}
            value={this.props.tradeInDetails.applyFinanceForTradeIn}
          />
        </Grid>

        <Grid container>
          <GridItem
            label={this.props.t("TradeIn.vehicleMileage")}
            value={this.props.tradeInDetails.mileage}
          />

          <GridItem
            label={this.props.t("TradeIn.bodyType")}
            value={this.props.tradeInDetails.trim}
          />

          <GridItem
            label={this.props.t("TradeIn.modelYear")}
            value={this.props.tradeInDetails.modelYear}
          />

          <HasPermissionTo
            perform={["vendorId:view"]}
            permissions={this.props.user.permissions.rolePermissions}
            render={() => (
              <GridItem
                label={this.props.t("TradeIn.vendorId")}
                value={this.props.tradeInDetails.vendorAppraisalId}
              />
            )}
          />
        </Grid>

        <Grid container>
          <GridItem
            label={this.props.t("TradeIn.make")}
            value={this.props.tradeInDetails.vehicleMake}
          />

          <GridItem
            label={this.props.t("TradeIn.fuelType")}
            value={this.props.tradeInDetails.fuelType}
          />

          <GridItem
            label={this.props.t("TradeIn.tradeInValuation")}
            value={this.props.appraisalAmount}
            edit={
              this.canViewTradeIn &&
              this.canWriteTradeIn &&
              !this.props.handOverComplete
            }
            info={
              this.canViewTradeIn &&
              NOTNULL_OR_NOTUNDEFINED(this.props.tradeInDetails.userId)
            }
            infoVersion={2}
          />

          <HasPermissionTo
            perform={["tradeIn:view"]}
            permissions={this.props.user.permissions.rolePermissions}
            render={() => (
              <GridItem
                label={
                  CapitalizeText(this.props.t("TradeIn.outstandingFinance")) +
                  ":"
                }
                value={this.props.outstandingFinance}
                edit={this.canWriteTradeIn && !this.props.handOverComplete}
                info={NOTNULL_OR_NOTUNDEFINED(this.props.tradeInDetails.userId)}
                infoVersion={1}
              />
            )}
          />
        </Grid>
      </div>
    );
  }
}

export default withTranslation("emp")(OnlineTradeIn);
